module.exports = __webpack_public_path__ + "static/img/d.cd7b2f65.png";